import { DosageRepeat } from "@/service/models/common/query-dosage/dosage-choices";
import { BaseDosageChoiceVM } from "./base-dosage-choice-vm";

export class DosageRepeatVM extends BaseDosageChoiceVM
{
    public iterations: number|null = null;
    public dosage: BaseDosageChoiceVM|null = null;

    /**
     * @inheritdoc
     */
    public isValid(): boolean
    {
        return (
            this.iterations !== null &&
            this.dosage !== null &&
            this.dosage.isValid()
        );
    }

    /**
     * @inheritdoc
     */
    public getModel(): DosageRepeat
    {
        if (
            this.iterations === null ||
            this.dosage === null
        ) {
            throw new Error("Not enough data to populate model");
        }

        return new DosageRepeat(this.iterations, this.dosage.getModel());
    }

    /**
     * @inheritdoc
     */
    public fillFromModel(model: DosageRepeat): DosageRepeatVM
    {
        this.iterations = model.iterations;
        this.dosage = model.dosage.makeViewModel();

        return this;
    }
}
